import { useCallback } from "react";

import { Tooltip, IconButton, Box } from "@material-ui/core";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import LoadingData from "components/Loading/LoadingData";

import { columnTextField } from "utils/tables-utils";
import MaskAndValid from "utils/maskAndValid";

import VisibilityIcon from "@mui/icons-material/Visibility";

function formatDate(value) {
  if (!value) return "—";
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleDateString("pt-BR");
  } catch {
    return String(value);
  }
}

export default function TablePrePedidos({
  data,
  loading,
  loadingDetails,
  totalSize,
  currentPage,
  currentSizePerPage,
  onTableChange,
  onPageChange,
  handleViewDetails,
}) {
  const columnModel = [
    columnTextField({
      dataField: "CnpjLoja",
      text: "CNPJ",
      align: "center",
      formatter: (cell) => (cell?.trim() ? MaskAndValid.maskCNPJ(cell) : null) || "—",
    }),
    columnTextField({
      dataField: "RazaoSocialLoja",
      text: "Consumidor",
      formatter: (cell) => cell?.trim() || "—",
      align: "center",
      style: {
        maxWidth: "20vw",
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
    }),
    columnTextField({
      dataField: "IdVitrineVirtualB2b",
      text: "Cód. Vitrine",
      align: "center",
    }),
    columnTextField({
      dataField: "NomeVitrine",
      text: "Vitrine B2B",
      align: "center",
      style: {
        maxWidth: "20vw",
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
    }),
    columnTextField({
      dataField: "DataPrePedido",
      text: "Data Pré-pedido",
      align: "center",
      formatter: (cell) => formatDate(cell),
    }),
    columnTextField({
      dataField: "ValorTotal",
      text: "Valor Total",
      align: "center",
      formatter: (cell) => `R$ ${MaskAndValid.maskPrice(cell ?? 0)}`,
    }),
    columnTextField({
      dataField: "VigenciaInicioFormat",
      text: "Vigência",
      align: "center",
      formatter: (_, row) => {
        const ini = row.VigenciaInicioFormat;
        const fim = row.VigenciaFimFormat;
        if (!ini && !fim) return "—";
        if (ini && fim) return `${ini} - ${fim}`;
        return ini || fim;
      },
    }),
    columnTextField({
      dataField: "Status",
      text: "Status",
      align: "center",
      formatter: (_, row) => {
        const status = row.Status || "Criado";
        return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
      },
    }),
    {
      dataField: "selected",
      text: "",
      align: "center",
      headerAlign: "center",
      formatter: (_, row) => (
        <Box display="flex" justifyContent="flex-start" style={{ gap: 4 }}>
          <Tooltip title="Ver detalhes do pré-pedido">
            <IconButton
              size="small"
              aria-label="detalhes-pre-pedido"
              onClick={() => handleViewDetails(row.IdVitrineVirtualB2bPedido)}
              disabled={loadingDetails}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      onPageChange(page, sizePerPage);
    },
    [onPageChange],
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      onPageChange(page, sizePerPage);
    },
    [onPageChange],
  );

  return (
    <div>
      {loading ? (
        <LoadingData searching={true} label="Buscando dados..." />
      ) : (
        <ToolkitTable
          keyField="IdVitrineVirtualB2bPedido"
          dataTable={data}
          columnModel={columnModel}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
          bootstrapTableProps={{
            remote: true,
            onTableChange: onTableChange,
          }}
          pagination={{
            options: [25, 50, 100],
            totalSize: totalSize,
            page: currentPage + 1,
            sizePerPage: currentSizePerPage,
            defaultOption: 25,
            showTotal: true,
            onPageChange: handlePageChange,
            onSizePerPageChange: handleSizePerPageChange,
          }}
        />
      )}
    </div>
  );
}
